import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/card';
import {Header,Footer} from "../../component/ing/common/shared";

@Component({
  templateUrl: './card.component.html'
})
export class CardComponent implements OnInit {

	code = Code;
	parameters: any[];
	headers: any[];
	styleName: any[];
	styleValue: any[];
	constructor() {

	}

	ngOnInit() {
		this.parameters = [
			{name: "title",type: "string",default: "null",des: "卡片的标题。"},
			{name: "subtitle",type: "string",default: "null",des: "卡片的次要标题"},
			{name: "style",type: "string",default: "null",des: "组件的内联样式。"},
			{name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
		];
		
		this.headers = [
			{name : "名字"},
			{name : "类型"},
			{name : "默认"},
			{name : "描述"}
		];

		this.styleName = [
			{name : "名称"},
			{name : "元素"}
		];

		this.styleValue = [
			{name : "ui-card", el: "容器元素"},
			{name : "ui-card-title", el: "标题元素"},
			{name : "ui-card-subtitle", el: "字幕元素。"},
			{name : "ui-card-content", el: "卡片的内容。"},
			{name : "ui-card-footer", el: "卡片的页脚。"}
		]
	}

}



// WEBPACK FOOTER //
// ./src/app/view/card/card.component.ts